<template>
  <div v-loading="loading" class="container_padding">
    <LearningPageBox>
      <template slot="title">
        <div
          v-if="list && list.title"
          class="progress_title"
        >《{{list.title}}》{{$t('message.learning_progress')}}</div>
      </template>
      <template slot="content">
        <div class="progress_content">
          <div class="tabs_div">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane :label="$t('message.all')" name="all"></el-tab-pane>
              <el-tab-pane :label="$t('message.learning')" name="learning"></el-tab-pane>
              <el-tab-pane :label="$t('message.finished_learning')" name="ended"></el-tab-pane>
            </el-tabs>
          </div>
          <el-row :gutter="16" v-if="chapters.length > 0" type="flex" style="flex-wrap: wrap">
            <el-col
              v-for="(item,index) in chapters"
              :key="item.id"
              :xs="24"
              :sm="12"
              :md="8"
              :lg="6"
              :xl="6"
              style="margin-bottom:16px;height: 100%"
            >
              <Chapters
                :data="item"
                :index="index"
                :btnLabel="percentage(item.progress) == 0 ?$t('message.to_learn') :percentage(item.progress) < 100 ? $t('message.continue_learning') : percentage(item.progress) >= 100 ? $t('message.learn_review'):$t('message.to_learn')"
                @click="handleBtnClick"
              ></Chapters>
            </el-col>
          </el-row>
          <div class="noData" v-if="chapters.length < 1">{{$t('message.noData')}}</div>
        </div>
      </template>
    </LearningPageBox>
  </div>
</template>

<script>
import CourseAPI from "../../api/CourseAPI";
import UserCourseAPI from "../../api/UserCourseAPI";
import LearningPageBox from "../../components/LearningPageBox";
import Chapters from "../../components/Chapters";
export default {
  components: { LearningPageBox, Chapters },
  data() {
    return {
      loading: false,
      list: {},
      chapters: [],
      activeName: "all"
    };
  },
  computed: {
    percentage() {
      return function(val) {
        return parseInt(val.replace("%", ""));
      };
    },
    myQuery() {
      return this.$route.query;
    }
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab);
      // console.log(event);
      this.get(this.activeName);
    },

    handleBtnClick(data, index) {
      // console.log(data);
      // console.log(this.percentage(data.progress));
      // const progress = this.percentage(data.progress);
      console.log("index", index);

      if (!this.$store.state.isPreview) {
        UserCourseAPI.addUserCourse(this.list.id)
          .then(() => {
            this.$router.push({
              path: "/learning/course",
              query: {
                ...this.myQuery,
                chapterIndex: index,
                activeName: "content"
              }
            });
          })
          .catch(err => {
            this.$error(err);
          });
      } else {
        this.$router.push({
          path: "/learning/course",
          query: {
            ...this.myQuery,
            chapterIndex: index,
            activeName: "content"
          }
        });
      }
      // if (progress >= 100) {
      //   this.$router.push({
      //     path: "/learning/record",
      //     query: {
      //       chapterId: data.id
      //     }
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/learning/course",
      //     query: {
      //       chapterIndex: index
      //     }
      //   });
      // }
    },
    get(activeName) {
      this.loading = true;
      const id = sessionStorage.getItem("courseId");
      const locale = this.$i18n.locale;
      CourseAPI.getOne(id, locale)
        .then(res => {
          this.loading = false;
          // res.chapters = [
          //   ...res.chapters,
          //   ...res.chapters,
          //   ...res.chapters,
          //   ...res.chapters
          // ];
          this.list = res;
          if (activeName == "all") {
            this.chapters = res.chapters;
          } else if (activeName == "ended") {
            this.chapters = res.chapters.filter(
              item => parseInt(item.progress.replace("%", "")) >= 100
            );
          } else {
            this.chapters = res.chapters.filter(
              item => parseInt(item.progress.replace("%", "")) < 100
            );
          }
        })
        .catch(err => {
          this.loading = false;
          this.$error(err);
          console.log(err);
        });
    }
  },
  created() {
    this.get(this.activeName);
  }
};
</script>

<style lang="scss" scoped>
.progress_content {
  padding: 0 2% 1% 2%;
}
.progress_title {
  text-align: center;
}
.tabs_div {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(155, 155, 155, 0.3);
}
/deep/.el-tabs__header {
  margin: 0px;

  .el-tabs__item {
    font-size: 16px;
    color: #3e4143;
  }

  .el-tabs__item:hover,
  .el-tabs__item.is-active {
    color: #16b695;
  }

  .el-tabs__active-bar {
    background-color: #16b695;
    height: 4px;
    border-radius: 3px;
    padding: 0 5px;
    left: -4px;
  }

  .el-tabs__nav-wrap::after {
    height: 0;
  }

  .el-tabs__nav {
    margin-left: 10px;
  }
}
</style>
